import React, { ComponentProps, forwardRef } from 'react';
import { Text } from '../Contents/Text';
import styles from './ChartContainer.module.css';

export type ChartContainerProps = Omit<ComponentProps<'div'>, 'title'> & {
  title?: React.ReactNode;
};

export const ChartContainer = forwardRef(
  (
    { title, children, ...props }: ChartContainerProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div {...props} className={styles.container} ref={ref}>
        {React.isValidElement(title) ? (
          title
        ) : (
          <Text textStyle={Text.Style.BodyMdSemibold}>{title}</Text>
        )}
        <div className={styles.chartWrapper}>{children}</div>
      </div>
    );
  },
);
